<style lang="stylus">
  @import '../../static/stylus/main.styl'
</style>
<template lang="pug">
c-app
  c-sider.u-hidden-up
    c-brand(slot='start')
      img(src='../assets/logo-white.svg', alt='Cover')
    
  c-content
    header.header_app
      consultor-navbar
    c-body.container.pt-5.pb-4
      router-view
    footer-bar
</template>

<script>
import Navigation from '../components/navigation.vue'
import ConsultorNavbar from '../components/consultor-navbar.vue'
import FooterBar from '../components/footer.vue'

export default {

  name: 'Consultor',
  components: {
    Navigation,
    ConsultorNavbar,
    FooterBar
  },

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/consultor.vue